/**
 * Translated routes file
 * Locale: en
 */

// Page components
import Home        from '../components/Home.vue';
import Pib         from '../components/content/categories/Pib.vue';
import Exchange    from '../components/content/categories/Exchange.vue';
import Immigration from '../components/content/categories/Immigration.vue';
import Analyse     from '../components/content/categories/Analyse.vue';
import NotFound    from '../components/NotFound.vue';

// Vue-i18n
import i18n from '../libraries/i18n.js';

export default [
    {
        path: '/',
        name: 'home:en',
        component: Home,
        meta: { locale: 'en' }
    },
    {
        path: '/gross-domestic-product',
        name: 'pib:en',
        component: Pib,
        meta: { locale: 'en', title: i18n.t('gross-domestic', 'en') }
    },
    {
        path: '/international-commerce',
        name: 'exchange:en',
        component: Exchange,
        meta: { locale: 'en', title: i18n.t('commercial-exchanges', 'en') }
    },
    {
        path: '/human-resource',
        name: 'immigration:en',
        component: Immigration,
        meta: { locale: 'en', title: i18n.t('human-resource', 'en') }
    },
    {
        path: '/international-partners',
        name: 'analyse:en',
        component: Analyse,
        meta: { locale: 'en', title: i18n.t('foreign-investment', 'en') }
    },
    {
        path: '*',
        name: '404:en',
        component: NotFound
    },
    {
        path: '/bankofcanadamuseum.ca',
        name: 'bankofcanadamuseum:en',
        beforeEnter () {
            window.location.href = 'https://www.bankofcanadamuseum.ca/';
        },
        meta: { locale: 'en', title: i18n.t('bankofcanadamuseum', 'en') }
    },
];
